"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M13.636 2s.673 2.485.673 4.5c0 1.932-1.227 3.498-3.1 3.498-1.882 0-3.3-1.566-3.3-3.497l.027-.338C6.1 8.413 5 11.33 5 14.5c0 4.143 3.255 7.5 7.273 7.5s7.273-3.357 7.273-7.501c0-5.054-2.355-9.564-5.91-12.499zm-1.753 11.711c-1.237.263-1.973 1.088-1.973 2.26 0 1.256 1.01 2.27 2.264 2.27 1.863 0 3.372-1.557 3.372-3.48 0-1.003-.136-1.987-.418-2.925-.718 1.003-2 1.613-3.245 1.875zm-5.065.788c0 3.103 2.446 5.626 5.455 5.626 3.01 0 5.455-2.523 5.455-5.626 0-2.4-.6-4.717-1.719-6.78-.481 2.439-2.381 4.154-4.8 4.154A4.999 4.999 0 0 1 7.6 10.345a11.454 11.454 0 0 0-.782 4.154z", clipRule: "evenodd" }))); };
var SvgFire = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgFire');
exports.default = SvgFire;
